import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import Header from "./components/Header";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import AccountPlans from "./components/AccountPlans";
import TradingRules from "./components/TradingRules";
import Features from "./components/Features";
import TrustpilotSection from "./components/TrustpilotSection";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import LiveChat from "./components/LiveChat";

// Auth Pages
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLoginTest from "./pages/AdminLoginTest";

// Legal Pages
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import RiskDisclosure from "./pages/RiskDisclosure";
import CookiePolicy from "./pages/CookiePolicy";
import TradingRulesPage from "./pages/TradingRulesPage";

const LandingPage = () => {
  return (
    <div>
      <Header />
      <Hero />
      <HowItWorks />
      <AccountPlans />
      <TradingRules />
      <Features />
      <TrustpilotSection />
      <FAQ />
      <Footer />
      <LiveChat />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/r/:refCode" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/test-admin-login" element={<AdminLoginTest />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <UserDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/admin" 
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route path="*" element={<Navigate to="/" replace />} />
              
              {/* Legal Pages */}
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/risk-disclosure" element={<RiskDisclosure />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route path="/trading-rules" element={<TradingRulesPage />} />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
